import * as tslib_1 from "tslib";
import { Store, StoreConfig } from '@datorama/akita';
import * as i0 from "@angular/core";
export function createPageInitialState() {
    return {
        loadersCount: 0
    };
}
var PageStore = /** @class */ (function (_super) {
    tslib_1.__extends(PageStore, _super);
    function PageStore() {
        return _super.call(this, createPageInitialState()) || this;
    }
    PageStore.ngInjectableDef = i0.defineInjectable({ factory: function PageStore_Factory() { return new PageStore(); }, token: PageStore, providedIn: "root" });
    PageStore = tslib_1.__decorate([
        StoreConfig({ name: 'page' }),
        tslib_1.__metadata("design:paramtypes", [])
    ], PageStore);
    return PageStore;
}(Store));
export { PageStore };
